module.exports = __webpack_public_path__ + "static/images/circle-gray-empty.1shPFuk.svg";